import striptags from 'striptags';
import { htmlDecode } from 'htmlencode';
export default (function (htmlContent) {
  return htmlDecode(striptags(htmlContent));
});